import React, { useEffect, useState } from 'react';
import InputField from '../../../component/form/FormInput';
import { useNavigate, useParams } from 'react-router-dom';
import Button from '../../../component/ui/Button';
import InputSelect from '../../../component/inputSelect/InputSelect';
import AdjustmentTable from './AdjustmentTable';
import { useDispatch, useSelector } from 'react-redux';
import pdfMake from 'pdfmake/build/pdfmake';
import {
	getRefNumber,
	inventoryAdjustmentConvert,
	inventoryAdjustmentCreate,
	inventoryAdjustmentDelete,
	inventoryAdjustmentReverted,
	inventoryAdjustmentUpdate,
} from '../../../store/action/inventory';
import { toast } from 'react-toastify';

import { formatErrors, hasPermission } from '../../../utils/controller';
import ConfirmationModal from '../../../component/modal/ConfirmationModal';
import {
	fetchAdjustmentAccounts,
	fetchInventoryAdjustmentList,
	fetchInventoryAdjustmentListForDetails,
	fetchReasonList,
	generateInventoryAdjustmentPdf,
} from '../../../services/adjustments';
import { generateAdjustmentPdf } from './components/generateAdjustmentPdf';

const Adjustment = () => {
	const dispatch = useDispatch();
	const today = new Date().toISOString().split('T')[0];
	const navigate = useNavigate();
	const param = useParams();
	const [loading, setLoading] = useState({
		pdf: {
			button: 'pdf',
			isLoading: false,
		},
		download: {
			button: 'download',
			isLoading: false,
		},
	});
	const inventoryAdjustmentId = param?.id;
	const [refnumber, setrefnumber] = useState('');
	const [date, setDate] = useState(today);
	const [account, setAccount] = useState('');
	const [reason, setReason] = useState('');
	const [description, setDescription] = useState('');
	const [tableData, setTableData] = useState([]);
	const [error, setError] = useState({});
	const [loader, setLoader] = useState(false);
	const [convrsionLoader, setConversionLoader] = useState(false);
	const [inventoryTableError, setInventoryTableError] = useState(false);
	const [isErrortable, setIsTableError] = useState(false);
	const [reasonOption, setReasonOption] = useState([]);
	const [accountOption, setAcctountOption] = useState([]);
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const [ModalState, setModalState] = useState({
		title: '',
		content: '',
		handleSubmit: null,
	});
	const [inventoryAdjustmentDetails, setInventoryAdjustmentDetails] = useState();
	const [showModal, setShowModal] = useState(false);
	const [disabled, setDisabled] = useState(inventoryAdjustmentId ? true : false);

	const saveinventoryAdjust = (value) => {
		if (isErrortable === false) {
			if (value === 1 && inventoryAdjustmentId) {
				setConversionLoader(true);

				dispatch(inventoryAdjustmentConvert(inventoryAdjustmentId))
					.then((res) => {
						if (res?.success) {
							toast.success(res?.message);
							navigate(-1);
							setLoader(false);
						} else {
							toast.error(res?.message);
							setLoader(false);
						}
					})
					.catch((error) => {
						setLoader(false);
					});
			} else {
				setLoader(true);
				let adjustMentDetils = [];
				tableData?.map((ele) => {
					adjustMentDetils?.push({
						product_id: isNaN(ele?.product_id) ? ele?.product_name : ele?.product_id,
						batch_id: ele?.batch_id,
						quantity_adjusted: Number(ele?.quantity_adjusted),
					});
				});

				const formData = {
					adjustment_date: date,
					account_id: account ? Number(account) : '',
					reason_id: reason ? Number(reason) : '',
					description: description,
					is_draft: value,
					adjustment_details: adjustMentDetils,
					reference_number: refnumber,
				};
				dispatch(inventoryAdjustmentCreate(formData))
					.then((res) => {
						if (res?.success) {
							toast.success(res?.message);
							navigate(-1);
							setLoader(false);
						} else {
							toast.error(res?.message);
							let error = formatErrors(res?.data?.message);
							setInventoryTableError(true);
							toast.error(error?.adjustment_details);
							setError(error);
							setLoader(false);
						}
					})
					.catch((error) => {
						toast.error(error?.message);
						setLoader(false);
						setConversionLoader(false);
					});
			}
		} else {
			toast.error('Error in add inventory table to know more click on show all error .');
			setInventoryTableError(true);
		}
		setLoader(false);
		setConversionLoader(false);
	};

	const handledelete = () => {
		dispatch(inventoryAdjustmentDelete(inventoryAdjustmentId)).then((res) => {
			if (res?.success) {
				toast.success(res?.message);
				navigate(-1);
			} else {
				toast.error(res?.message);
			}
		});
	};

	const navigateRouter = (path) => {
		navigate(path);
	};

	const updateInventory = () => {
		let id = inventoryAdjustmentId;
		let adjustMentDetils = [];
		tableData?.map((ele) => {
			adjustMentDetils?.push({
				product_id: isNaN(ele?.product_id) ? ele?.product_name : ele?.product_id,
				batch_id: isNaN(ele?.batch_id) ? ele?.batch_no : ele?.batch_id,
				quantity_adjusted: Number(ele?.quantity_adjusted),
				adjustment_details_id: Number(ele?.adjustment_details_id),
			});
		});

		const formData = {
			adjustment_date: date,
			account_id: account ? Number(account) : '',
			reason_id: reason ? Number(reason) : null,
			description: description || '',
			is_draft: 1,
			adjustment_details: adjustMentDetils,
			reference_number: refnumber,
		};
		dispatch(inventoryAdjustmentUpdate(id, formData)).then((res) => {
			if (res?.success) {
				toast.success(res?.message);
				navigate(-1);
			} else {
			}
		});
	};

	async function handlePrintAndDownloadPdf(isPrint) {
		setLoading((prev) => {
			const obj = {};
			if (isPrint) {
				obj.pdf = {
					button: 'pdf',
					isLoading: true,
				};
			} else {
				obj.download = {
					button: 'download',
					isLoading: true,
				};
			}

			return {
				...prev,
				...obj,
			};
		});

		const mergedDocDefinition = await generateAdjustmentPdf(inventoryAdjustmentId);
		if (isPrint) {
			pdfMake.createPdf(mergedDocDefinition).print();
		} else {
			pdfMake.createPdf(mergedDocDefinition).download();
		}

		setLoading((prev) => ({
			...prev,
			pdf: {
				...prev.pdf,
				isLoading: false,
			},
			download: {
				...prev.download,
				isLoading: false,
			},
		}));
	}

	async function handleAdjustmentPrintAndDownloadPdf(type = 'print') {
		try {
			setLoading((prev) => {
				const obj = {};
				if (type === 'print') {
					obj.pdf = {
						button: type,
						isLoading: true,
					};
				} else if (type === 'download') {
					obj.download = {
						button: type,
						isLoading: true,
					};
				}

				return {
					...prev,
					...obj,
				};
			});
			const pdf_details = await generateInventoryAdjustmentPdf(inventoryAdjustmentId);
			const url = pdf_details.signed_url;

			if (type === 'print') {
				window.open(url, '_blank');
			}

			if (type === 'download') {
				const fileName = `inventory_adjustment_${Date.now()}.pdf`;
				const response = await fetch(url);
				const blob = await response.blob();
				const blobUrl = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = blobUrl;
				link.download = fileName;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				window.URL.revokeObjectURL(blobUrl);
			}
		} catch (err) {
		} finally {
			setLoading((prev) => ({
				...prev,
				pdf: {
					...prev.pdf,
					isLoading: false,
				},
				download: {
					...prev.download,
					isLoading: false,
				},
			}));
		}
	}

	const revertAsAdjusted = () => {
		setConversionLoader(true);

		dispatch(inventoryAdjustmentReverted(inventoryAdjustmentId))
			.then((res) => {
				if (res?.success) {
					toast.success(res?.message);
					navigate(-1);
					setLoader(false);
				} else {
					toast.error(res?.message);
					setLoader(false);
				}
			})
			.catch((error) => {
				setLoader(false);
			});
	};

	const handleConfirmationModal = (data) => {
		if (data === 'delete') {
			setModalState({
				title: 'Inventory Adjustment',
				content: 'Are you sure want to delete ?',
				handleSubmit: handledelete,
			});
		} else if (data === 'reverted') {
			setModalState({
				title: 'Inventory Adjustment',
				content: 'Are you sure you want to revert this entry?',
				handleSubmit: revertAsAdjusted,
			});
		}
		setShowModal(true);
	};

	const handleAccount = (value) => {
		setAccount(value);
		if (value) {
			setError({});
		}
	};

	const initialData = async () => {
		try {
			setTableData([]);
			if (inventoryAdjustmentId) {
				let param = `filterBy=adjustment_id&filterValue=${inventoryAdjustmentId}`;
				let res = await fetchInventoryAdjustmentListForDetails(param);
				if (res?.success) {
					const data = res.data.data.inventoryAdjustment[0];
					let adjusmentdetails = [];
					data?.adjusmentdetails?.map((item) => {
						adjusmentdetails?.push({
							product_id: item?.product?.product_name,
							batch_id: item?.product_batch?.batch_no?.toString(),
							quantity_adjusted: item?.quantity_adjusted,
							adjustment_details_id: item?.adjustment_details_id,
							batch_no: item?.product_batch_id,
							product_name: item?.product_id,
							qty: item?.product_batch?.quantity,
							qtyHand: `${
								data.is_draft === 0
									? Number(item?.product_batch?.quantity) - Number(item?.quantity_adjusted)
									: Number(item?.product_batch?.quantity) + Number(item?.quantity_adjusted)
							}`,
						});
					});
					setInventoryAdjustmentDetails(data);
					setrefnumber(data?.reference_number);
					setDate(data?.date);
					setAccount(data?.account_id || '');
					setReason(data?.reason_id || '');
					setDescription(data?.description || '');
					setTableData(adjusmentdetails);
				}
			}

			if (!inventoryAdjustmentId) {
				getRefNumber().then((res) => {
					if (res?.success) {
						setrefnumber(res?.data);
					} else {
					}
				});
			}

			const resAccounts = await fetchAdjustmentAccounts();
			const resReason = await fetchReasonList();
			if (resAccounts.success) {
				const accountList = resAccounts.data.map((acc) => {
					return { key: acc.account_id, value: acc.account_name };
				});
				setAcctountOption(accountList);
			}
			if (resReason.success) {
				const reasonList = resReason.data.map((reason) => {
					return { key: reason.reason_id, value: reason.reason_description };
				});
				setReasonOption(reasonList);
			}
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		}
	};

	useEffect(() => {
		initialData();
	}, [inventoryAdjustmentId]);

	return (
		<div id="pdf-content">
			<div className="product-pg-header add-product">
				<p>Add New Adjustment</p>
				<div className="add-product-button">
					{disabled === true && inventoryAdjustmentDetails?.is_draft === 0 && (
						<Button
							type="button"
							className="btn-gray mt-0 px-4"
							disabled={
								!hasPermission('inventory.adjustments.create', user?.role?.role_permissions)
							}
							button="Edit"
							onClick={() => setDisabled(false)}
						/>
					)}
					{disabled === true && (
						<Button
							type="button"
							className="btn-gray mt-0 px-4"
							button="Print"
							loader={loading.pdf.isLoading}
							onClick={() => handleAdjustmentPrintAndDownloadPdf('print')}
						/>
					)}
					{disabled === true && (
						<Button
							type="button"
							className="btn-gray mt-0 px-4"
							button="Download"
							loader={loading.download.isLoading}
							onClick={() => handleAdjustmentPrintAndDownloadPdf('download')}
						/>
					)}
					{inventoryAdjustmentId &&
						disabled === true &&
						inventoryAdjustmentDetails?.is_draft === 0 && (
							<Button
								type="button"
								className="btn-gray mt-0 px-4"
								disabled={
									!hasPermission('inventory.adjustments.delete', user?.role?.role_permissions)
								}
								button="Delete"
								onClick={() => handleConfirmationModal('delete')}
							/>
						)}

					{disabled === false && !inventoryAdjustmentId && (
						<Button
							type="button"
							className="mt-0 w-100 px-5 btn-primary"
							button="Save as Draft"
							disabled={
								!hasPermission('inventory.adjustments.create', user?.role?.role_permissions)
							}
							onClick={() => saveinventoryAdjust(0)}
							loader={loader}
						/>
					)}
					{disabled === false && inventoryAdjustmentId && (
						<Button
							type="button"
							className="mt-0 w-100 px-5 btn-primary"
							disabled={
								!hasPermission('inventory.adjustments.create', user?.role?.role_permissions)
							}
							button="Save as Draft"
							onClick={updateInventory}
						/>
					)}
					{((disabled === false && !inventoryAdjustmentId) ||
						inventoryAdjustmentDetails?.is_draft === 0) && (
						<Button
							type="button"
							className="mt-0 w-100 px-5 btn-primary"
							disabled={
								inventoryAdjustmentId
									? !hasPermission('inventory.adjustments.edit', user?.role?.role_permissions)
									: !hasPermission('inventory.adjustments.create', user?.role?.role_permissions)
							}
							button="Convert as Adjusted"
							onClick={() => saveinventoryAdjust(1)}
							loader={convrsionLoader}
						/>
					)}
					{inventoryAdjustmentDetails?.is_draft === 1 && (
						<Button
							type="button"
							className="mt-0 w-100 px-5 btn-primary"
							disabled={
								inventoryAdjustmentId
									? !hasPermission('inventory.adjustments.edit', user?.role?.role_permissions)
									: !hasPermission('inventory.adjustments.create', user?.role?.role_permissions)
							}
							button="Revert as Adjusted"
							onClick={() => handleConfirmationModal('reverted')}
							loader={convrsionLoader}
						/>
					)}
					{
						<Button
							type="button"
							className="mt-0 btn-danger add-pro"
							close
							button=""
							onClick={() => navigateRouter(-1)}
						/>
					}
				</div>
			</div>
			<div
				className="max-w-1297"
				style={{ padding: '1rem 2rem 0' }}
			>
				<div className="row">
					<div className="col-6">
						<InputField
							label="Reference Number"
							placeholder="Ref#"
							type="text"
							autoFocus={true}
							onChange={(val) => setrefnumber(val)}
							value={refnumber}
							disabled
							required={true}
						/>
					</div>
					<div className="col-6">
						<InputField
							label="Date"
							placeholder="Enter Date"
							type="date"
							onChange={(val) => setDate(val)}
							value={date}
							autoFocus={disabled ? false : true}
							disabled={disabled}
							required={true}
							error={error?.date}
						/>
					</div>
				</div>
				<div className="row">
					<div className="col-6">
						<InputSelect
							label="Account"
							placeholder="Select Account"
							onChange={(value) => handleAccount(value)}
							value={account}
							options={accountOption}
							disabled={disabled}
							required={true}
							error={error?.account_id}
						/>
					</div>
					<div className="col-6">
						<InputSelect
							label="Reason"
							placeholder="Select Reason"
							onChange={(value) => setReason(value)}
							value={reason}
							options={reasonOption}
							disabled={disabled}
							error={error?.reason}
						/>
					</div>
				</div>
				<div className="row my-1">
					<div className="col-12">
						<InputField
							label="Description"
							placeholder="Provides notes if any"
							type="text"
							onChange={(val) => setDescription(val)}
							value={description}
							disabled={disabled}
							error={error?.description}
						/>
					</div>
				</div>
			</div>
			<AdjustmentTable
				tableData={tableData}
				setTableData={setTableData}
				disabled={disabled}
				paramId={inventoryAdjustmentId}
				tableError={inventoryTableError}
				setIsTableErrorShow={setIsTableError}
			/>
			<div>
				{showModal && (
					<ConfirmationModal
						isOpen={showModal}
						onClose={() => setShowModal(false)}
						onCancel={() => setShowModal(false)}
						onOk={revertAsAdjusted}
						title={ModalState?.title}
						content={ModalState?.content}
						handleSubmit={ModalState?.handleSubmit}
					/>
				)}
			</div>
		</div>
	);
};

export default Adjustment;
